export default __webpack_public_path__ + "static/media/stackable_ring.80b8f900.png";